import React from 'react'
import styles from './Banner.module.css'

/**
 * Banner — renders the authentic "Dr Lal PathLabs / Authorized Collection Center /
 * Nextgen Health Care" banner provided in the requirement.
 *
 * It features:
 * - The authentic red DNA double helix logo
 * - The authentic signature "Dr Lal PathLabs" script font
 * - Odia script translation
 * - "Authorized Collection Center / Nextgen Health Care"
 */
const Banner: React.FC = () => {
  return (
    <aside className={styles.banner} aria-label="Authorized collection center banner">
      <div className={styles.banner__inner}>
        <img
          src="/assets/banner-full.jpg"
          alt="Dr Lal PathLabs - Authorized Collection Center Nextgen Health Care"
          className={styles.banner__image}
          loading="eager"
        />
      </div>
    </aside>
  )
}

export default Banner
